<ul class="list-group" style="margin-bottom: 0;">
	<ng-container *ngFor="let user of connectedUsers()">
		<li style="border: 0;" class="list-group-item">
			<i class="fa fa-circle text-success"></i>
			<span class="text-primary">{{user}}</span>
		</li>
	</ng-container>
</ul>